import React, { useEffect, useState, memo } from "react";
import Download from "./Download";
import { Manifest as _Manifest, H1, H2 } from "./__styles__";
import getPluginsApi from "../__hooks__/usePlugins";

const Manifest = memo(({ system = "", versions = [] }) => {
  const [manifests, setManifests] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const fetchManifests = async () => {
      setLoading(true);

      const fetchedManifests = await Promise.all(
        versions.map(async (item) => {
          const manifest = await getPluginsApi(item.manifest, item.path);
          if (manifest) {
            manifest[0].path = item.path;
            return manifest[0];
          }
          return null;
        })
      );
      // Filter out any null or undefined results and sort by version
      const validManifests = fetchedManifests
        .filter(Boolean)
        .sort((a, b) => parseInt(b.version) - parseInt(a.version));
      setManifests(validManifests);
      setLoading(false);
    };

    fetchManifests();
  }, [versions]);

  return (
    <div key={system}>
      <H1 style={{ paddingLeft: 16 }}>{system} Plugins</H1>
      {isLoading && <div style={{ paddingLeft: 16 }}>Loading...</div>}
      {!isLoading && manifests.length > 0 && (
        <_Manifest style={{ paddingLeft: 16, marginTop: 16 }} key={system}>
          {manifests.map((manifest, idx) => (
            <Download
              key={idx}
              manifest={manifest}
              releasePath={manifest.path}
            />
          ))}
        </_Manifest>
      )}
      {!isLoading && manifests.length == 0 && (
        <div style={{ paddingLeft: 16 }}>No plugins available</div>
      )}
    </div>
  );
});

export default Manifest;
